import { render } from "./LTabBody.vue?vue&type=template&id=372c6cec"
import script from "./LTabBody.vue?vue&type=script&lang=js"
export * from "./LTabBody.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__